<div [id]="'modal-'+id" class="modal">
    <div class="box" role="dialog">
        <div class="wrapper">
            <div>
                <h2>{{header}}</h2>
            </div>
            <div class="box-content">
                <ng-content></ng-content>
            </div>
            <div class="box-footer">
                <button class="btn btn--primary right" (click)="close()">Stäng</button>
            </div>
        </div>
    </div>
</div>